import { createSlice } from "@reduxjs/toolkit";
import { ILabNumberState } from "../../pages/lab-inventory/type";

const initialState: ILabNumberState = {
  data: null,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  Details: null,
};

export const labNumberSlice = createSlice({
  name: "labNumber",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceLabNumber: (state, action) => {
      const { data, totalCount } = action.payload;
      state.data = data;
      state.totalCount = totalCount;
    },
    setLabNumberDetails: (state, action) => {
      state.Details = action.payload.data;
    },
  },
});

export const labNumberActions = labNumberSlice.actions;
export default labNumberSlice.reducer;